import { BoostSearchProvider } from '../platforms/boost/BoostSearchProvider';
import AppConfig from '../config/config';
/** A simple lookup so the factory can stay clean & typed. */
export const providerMap = {
    boost: BoostSearchProvider,
};
export function getSearchProvider(providerType, mockPlatform) {
    const provider = providerType || AppConfig.provider;
    switch (provider) {
        case 'boost':
            return new BoostSearchProvider();
        default:
            throw new Error(`Unsupported provider: ${provider}`);
    }
}
